import Bowser from "bowser";
const browser = Bowser.getParser(window.navigator.userAgent).parsedResult;
export default browser;